import type { Ref } from 'vue';
import { useExcelBlobExport } from '@/shared/lib';
import {
  trainingContentApi,
  type ExportTrainingContentsParams,
  type TrainingContentFilters,
  type TrainingContentSortField,
  type TrainingContentSortOrder,
} from '@/entities/Training';

interface UseTrainingContentsExportParams {
  term: Ref<string>;
  sort: Ref<TrainingContentSortField | ''>;
  order: Ref<TrainingContentSortOrder | ''>;
  filters: Ref<TrainingContentFilters>;
}

const ENTITY_LABEL = { singular: 'conteúdo', plural: 'conteúdos' };

export function useTrainingContentsExport({
  term,
  sort,
  order,
  filters,
}: UseTrainingContentsExportParams) {
  function buildExportParams(): ExportTrainingContentsParams {
    const trimmedTerm = term.value.trim();

    return {
      ...filters.value,
      ...(trimmedTerm ? { term: trimmedTerm } : {}),
      ...(sort.value && order.value ? { sort: sort.value, order: order.value } : {}),
    };
  }

  return useExcelBlobExport(
    () => trainingContentApi.exportTrainingContentsExcel(buildExportParams()),
    ENTITY_LABEL
  );
}
